export default {
 "Login": {
  "title": "Acceso restringido",
  "subtitle": "Terminal punto de venta",
  "username": "Usuario",
  "password": "Contraseña",
  "submit": "Entrar",
  "forgotten": "Ayuda! No puedo acceder",
  "backtologin": "Volver al inicio de sesión"
 },



 "Errors": {
  "needsupport": "Escribanos un correo a info@kesthers.com detallando su problema"


 }


}



// WEBPACK FOOTER //
// ./src/languages/spanish/index.js